import { render } from "./CustomerGroupIndex.vue?vue&type=template&id=ce6ebc74&scoped=true"
import script from "./CustomerGroupIndex.vue?vue&type=script&lang=js"
export * from "./CustomerGroupIndex.vue?vue&type=script&lang=js"

import "./CustomerGroupIndex.vue?vue&type=style&index=0&id=ce6ebc74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6ebc74"]])

export default __exports__